module.exports = __webpack_public_path__ + "static/media/boy.fb420713.jpg";